export function structureComments(history) {
   let commentsData = history.map((item) => {
      const [key] = Object.keys(item);
      const [values] = Object.values(item);
      const text = values.str;
      const comment = { ...values.hdr, commentType: key, text };
      return comment;
   });
   return commentsData;
}

export function assembleViewCommentsData(commentData) {
   const comment_data = structureComments(commentData.history);
   const commentIds = new Set();
   for (let comment of comment_data) {
      commentIds.add(comment.id);
   }
   const filteredComments = sortCommentsByCommentIds(commentIds, comment_data);
   const sortedComments = sortFilteredComments(filteredComments);
   const renderedComments = filterCommentsOut(sortedComments);
   return renderedComments;
}

function sortCommentsByCommentIds(commentIds, commentData) {
   let filteredComments = [];
   commentIds.forEach((id) => {
      let filteredComment = commentData.filter((comment) => {
         return id === comment.id;
      });
      filteredComments.push(filteredComment);
   });
   return filteredComments;
}
// Sort latest comment item to top
function sortFilteredComments(filteredComments) {
   let sortedComments = filteredComments.map((commentArray) => {
      let sorted = commentArray.sort((a, b) => {
         return new Date(b.time) - new Date(a.time);
      });
      return sorted;
   });
   return sortedComments;
}
// Only show the most recent update of a comment and comments that aren't deleted
function filterCommentsOut(sortedComments) {
   let renderedComments = sortedComments.map((comment) => {
      return comment[0];
      // run this to sort descending return comment[comment.length - 1];
   });
   // Remove deleted comment
   renderedComments = renderedComments.filter(
      (comm) => comm.commentType !== "CommunicationCommmentDelete",
   );
   return renderedComments.reverse();
}
